import { useMemo } from "react";
import { usePagination, useSorting } from "@/hooks";
import { GetPricingProfilesParams } from "@/redux/apis/config/trip/tripCost";

export const useGetPricingProfilesParams = () => {
  const { page, pageSize } = usePagination("pricing-profiles");
  const { sortKey, direction } = useSorting();

  const params: GetPricingProfilesParams = useMemo(
    () => ({
      page,
      page_size: pageSize,
      sort: sortKey,
      direction,
    }),
    [page, pageSize, sortKey, direction]
  );

  return { params };
};
